import { checkTransactionLoop } from '../../utils/common';
import { BuildModuleParamsType } from 'types/api-internal';
import {
  SugarMoneyApiPayoutProgressResponseType,
  SugarMoneyApiRequestPayoutResponseType,
  SugarMoneyApiSubmitPayoutRequestType,
  SugarMoneyTransactionStatusResponseType,
} from 'types/common';
import {
  SugarMoneyApiCreateReferralCodeRequestType,
  SugarMoneyApiCreateReferralCodeResponseType,
  SugarMoneyApiReferralCodeExistsRequestType,
  SugarMoneyApiReferralCodeExistsResponseType,
  SugarMoneyApiUserReferralsResponseType,
} from 'types/referrals';

export const referralsModule = ({
  makeApiRequest,
  checkTransactionStatus,
}: BuildModuleParamsType) => ({
  me: async () =>
    makeApiRequest<SugarMoneyApiUserReferralsResponseType>({
      endpoint: 'referrals/me',
      options: { method: 'get' },
    }),

  createReferralCode: async (data: SugarMoneyApiCreateReferralCodeRequestType) =>
    makeApiRequest<SugarMoneyApiCreateReferralCodeResponseType>({
      endpoint: 'referrals/me',
      data,
      options: { method: 'post' },
    }),

  codeExists: async ({ code }: SugarMoneyApiReferralCodeExistsRequestType) =>
    makeApiRequest<SugarMoneyApiReferralCodeExistsResponseType>({
      endpoint: `referrals/code-exists`,
      options: { method: 'get' },
      searchParams: { code },
    }),

  payout: {
    inProgress: async () =>
      makeApiRequest<SugarMoneyApiPayoutProgressResponseType>({
        endpoint: 'referrals/me/payout/in-progress',
        options: { method: 'get' },
      }),
    request: async () =>
      makeApiRequest<SugarMoneyApiRequestPayoutResponseType>({
        endpoint: 'referrals/me/payout/request',
        options: { method: 'post' },
      }),

    submit: async (data: SugarMoneyApiSubmitPayoutRequestType) => {
      const response = await makeApiRequest<SugarMoneyTransactionStatusResponseType>({
        endpoint: 'referrals/me/payout/submit',
        data,
        options: { method: 'post' },
      });

      return checkTransactionLoop({
        signature: response.signature,
        checkTransactionStatus,
      });
    },
  },
});
